import { render } from "./BoleteriaLink.vue?vue&type=template&id=e80c5896&scoped=true"
import script from "./BoleteriaLink.vue?vue&type=script&lang=js"
export * from "./BoleteriaLink.vue?vue&type=script&lang=js"

import "./BoleteriaLink.vue?vue&type=style&index=0&id=e80c5896&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e80c5896"]])

export default __exports__